import React from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import cx from "classnames";
import { useBreakpoints } from "@qgiv/core-react";
import { getInitialValues, getInitialTouched } from "./formik";
import ConnectedProductHeader from "./ConnectedProductHeader";
import ConnectedProductDescription from "./ConnectedProductDescription";
import ConnectedProductImages from "./ConnectedProductImages";
import ConnectedProductAttributes from "./ConnectedProductAttributes";
import ConnectedProductQuantity from "./ConnectedProductQuantity";
import ConnectedUpdateProductDetails from "./ConnectedUpdateProductDetails";
import "./ProductDetails.scss";

const ProductDetails = ({
    displayAttribute = false,
    displayDescription = false,
    displayImg = false,
    displayImageCarrousel = false,
    product,
    savedStoreCartValues,
    settings,
}) => {
    const { isSmallScreen } = useBreakpoints();

    const formikProps = {
        initialTouched: getInitialTouched(settings, savedStoreCartValues),
        initialValues: getInitialValues(
            settings,
            product,
            savedStoreCartValues,
        ),
    };

    return (
        <Formik {...formikProps}>
            <Form>
                <div className="store-details grid">
                    {displayImg && !isSmallScreen && (
                        <div className=" col col--6">
                            <div>
                                <ConnectedProductImages
                                    displayImageCarrousel={
                                        displayImageCarrousel
                                    }
                                />
                            </div>
                        </div>
                    )}
                    <div
                        className={cx(
                            "store-details__container col",
                            displayImg && "col--6",
                            !displayImg && !isSmallScreen && "col--8",
                            !displayImg && isSmallScreen && "col--12",
                        )}
                    >
                        <div className="store-details__container--header">
                            <ConnectedProductHeader />
                        </div>
                        {displayAttribute && (
                            <div className="store-details__container--attribute">
                                <ConnectedProductAttributes />
                            </div>
                        )}

                        <div className="store-details__container--quantity">
                            <ConnectedProductQuantity />
                        </div>
                        {displayImg && isSmallScreen && (
                            <div className="store-details__img-container">
                                <ConnectedProductImages
                                    displayImageCarrousel={
                                        displayImageCarrousel
                                    }
                                />
                            </div>
                        )}
                        {displayDescription && (
                            <div className="store-details__container--description">
                                <ConnectedProductDescription />
                            </div>
                        )}
                    </div>
                </div>
                <ConnectedUpdateProductDetails />
            </Form>
        </Formik>
    );
};

ProductDetails.propTypes = {
    displayAttribute: PropTypes.bool,
    displayDescription: PropTypes.bool,
    displayImg: PropTypes.bool,
    displayImageCarrousel: PropTypes.bool,
    product: PropTypes.shape({}).isRequired,
    savedStoreCartValues: PropTypes.shape({}).isRequired,
    settings: PropTypes.shape({}).isRequired,
};

export default ProductDetails;
